module.exports = __webpack_public_path__ + "img/fightcamp-letter.fe300ec9.svg";